import { Component, OnInit, inject } from '@angular/core';
import { IFilter, IQueryParam, IPopulate } from 'modelos/src';
import { IColumnas } from '../../../../../auxiliares/tabla/tabla.component';
import {
  IFiltroTabla,
  IRegExpSearch,
} from '../../../../../auxiliares/tabla/filtro/filtro.component';
import { HelperService } from '../../../../../auxiliares/servicios/helper.service';
import { MatDialog } from '@angular/material/dialog';
import { LoginService } from '../../../../login/login.service';
import { ISirena } from 'modelosSeguridad/src';
import { IntegracionesService } from '../../../../../auxiliares/servicios/http/integraciones.service';
import { Lista2Service } from '../../../../../auxiliares/servicios/lista2.service';
import { firstValueFrom } from 'rxjs';
import { escaparHtml } from '../../../../../auxiliares/html-seguro.util';
import { estadoHtml } from '../../../../../auxiliares/tabla/celdas';

@Component({
  selector: 'app-listado-sirenas',
  templateUrl: './listado-sirenas.component.html',
  styleUrl: './listado-sirenas.component.scss',
  standalone: false,
})
export class ListadoSirenasComponent implements OnInit {
  helper = inject(HelperService);
  private service = inject(IntegracionesService);
  dialog = inject(MatDialog);
  private lista2 = inject(Lista2Service);

  public clientePropio = LoginService.getCliente();
  //// Tabla nueva
  public name = 'ListadoSirenasComponent';
  public datos?: ISirena[];
  public datosTotal?: ISirena[];
  public totalCount = 0;
  public pageSize = this.helper.getPageSize(this.name);
  public columnas?: IColumnas<ISirena>[];
  //

  // FILTROS
  public search: IRegExpSearch = {
    fields: ['chipId'],
  };

  public filtros: IFiltroTabla[] = [];

  //Query
  public filter: IFilter<ISirena> = {};
  public populate: IPopulate[] = [];
  public query: IQueryParam = {
    page: 0,
    limit: +this.helper.getPageSize(this.name),
  };
  // Listados
  public async listar() {
    const res = await firstValueFrom(this.lista2.sirenas(this.query));
    this.totalCount = res?.totalCount || 0;
    this.datos = res?.datos || [];
  }

  // Acciones

  // Tabla

  private setColumnas() {
    this.columnas = [
      // Chip ID
      {
        header: {
          label: 'Chip ID',
        },
        row: {
          html: (dato) =>
            dato.chipId
              ? `<span class="tabla-codigo">${escaparHtml(String(dato.chipId))}</span>`
              : '',
          noData: 'Sin chip ID',
        },
      },
      // Conexión: en línea / sin conexión (antes, un ícono de wifi verde o rojo)
      {
        header: {
          label: 'Conexión',
          sortable: true,
          sort: 'online',
        },
        row: {
          // La imagen de wifi de siempre (verde / roja) + el estado en texto
          html: (dato) =>
            `<span class="tabla-celda-fila" style="gap:6px;">` +
            (dato.online
              ? `<img class="tabla-pin" src="assets/icons/wifi_24dp_75FB4C_FILL0_wght400_GRAD0_opsz24.svg" alt="" />${estadoHtml({ texto: 'En línea', tono: 'ok' })}`
              : `<img class="tabla-pin" src="assets/icons/wifi_24dp_EA3323_FILL0_wght400_GRAD0_opsz24.svg" alt="" />${estadoHtml({ texto: 'Sin conexión', tono: 'neutro' })}`) +
            `</span>`,
        },
      },
      {
        header: {
          label: 'Dirección',
        },
        row: {
          field: 'direccionGps',
          noData: 'Sin dirección',
        },
      },
    ];
  }

  // Hooks

  async ngOnInit() {
    this.setColumnas();
    await this.listar();
  }
}
